<template>
  <div class="productModel">
    <div class="header">
      <el-tabs :value="tabPaneValue" @tab-click="tabPaneClick">
        <el-tab-pane label="产品型号" name="first">
          <span
            @click="modelClick(null)"
            :class="{ activeLink: activeLink == null }"
            class="childTabs"
            >全部</span
          >
          <span
            v-for="(item, index) in pullDownData.productTypeList"
            :key="index"
            @click="modelClick(item.code)"
            :class="{ activeLink: activeLink == item.code }"
            class="childTabs"
            >{{ item.title }}</span
          >
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addNewBtn"
              >新建</el-button
            >
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-for="(item, index) in tabPaneList"
          :key="item.id"
          :label="item.name"
          :name="item.id"
        >
          <span slot="label">
            {{ item.code }}
            <i
              class="el-icon-circle-close"
              @click.stop="closeTabPane(index)"
            ></i>
          </span>
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'detail' }"
            @click="cutDetailChange('detail')"
            >产品详情</span
          >
          <span v-if="item.hasFw || item.hasMcu || item.hasWiFi || item.hasBt"
            class="childTabs"
            :class="{ activeLink: cutDetail == 'firmware' }"
            @click="cutDetailChange('firmware')"
            >固件管理</span
          >
          <span v-if="item.factoryTools.hasCommand"
            class="childTabs"
            :class="{ activeLink: cutDetail == 'commands' }"
            @click="cutDetailChange('commands')"
            >产测指令</span
          >
          <span v-if="item.batterySupport"
            class="childTabs"
            :class="{ activeLink: cutDetail == 'battery' }"
            @click="cutDetailChange('battery')"
            >电池曲线</span
          >
          <span v-if="item.hasIq" class="childTabs"
            :class="{ activeLink: cutDetail == 'iq' }"
            @click="cutDetailChange('iq')"
            >IQ二进制</span
          >
          <div class="btnBox" v-if="cutDetail == 'detail'">
            <el-button
              v-if="productDetailData.lockSop === true"
              type="primary"
              size="small"
              @click="unlockSopBtn"
            >解锁工序</el-button>
            <el-button
              v-else-if="productDetailData.lockSop === false"
              type="primary"
              size="small"
              @click="lockSopBtn"
            >锁定工序</el-button>
            <el-button
              type="primary"
              size="small"
              @click="editProductBtn"
            >修改</el-button>
          </div>
          <div class="btnBox" v-if="cutDetail == 'process'">
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addNewBtn"
              >添加</el-button
            >
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'firmware'">
            <div class="searchBtnBox">
            <el-button
              type="primary"
              size="small"
              @click="addNewBtn"
              >发布版本</el-button
            >
              <el-tooltip v-if="isMoreSearch"
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button v-if="isMoreSearch"
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'commands'">
            <el-button size="small" @click="copyBtn">复制</el-button>
            <el-button size="small" @click="addNewBtn" v-if="commandId !='' && commandId !=0">配置指令</el-button>
            <el-button size="small" @click="addNewComandBtn" v-if="commandId == '' ||  commandId == 0 ">新增指令</el-button>
            <el-button size="small" @click="deleteCommandArrayBtn" v-if="commandId == '' ||  commandId == 0 ">批量删除</el-button>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'battery'">
            <el-button size="small" @click="addBattery">新增</el-button>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'iq'">
            <el-button size="small" @click="addIq">新增</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-form
        :inline="true"
        :model="searchConditionForm"
        class="demo-form-inline"
        v-if="isMoreSearch && tabPaneValue == 'first'"
      >
        <div class="searchConditionBox">
          <el-form-item label="立项编码" size="small">
            <el-input
              v-model="searchConditionForm.code"
              placeholder="立项编码"
              clearable
              @keyup.enter.native="onSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="产测工具" size="small">
            <el-select
              v-model="searchConditionForm.factoryToolsId"
              placeholder="选择产测工具"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.factoryToolsList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Key类型" size="small" v-if="this.activeLink=='IPC' || this.activeLink=='CARDVR'">
            <el-select
              v-model="searchConditionForm.p2pType"
              placeholder="选择Key类型"
              filterable multiple
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.p2pTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="PID" size="small" v-if="this.activeLink=='IPC'">
            <el-input
              v-model="searchConditionForm.defaultPid"
              placeholder="PID"
              clearable
              :disabled="!(searchConditionForm.p2pType == 'NONE' || searchConditionForm.p2pType == 'LinkView' || searchConditionForm.p2pType == 'LinkViewByWakeUp' || searchConditionForm.p2pType == 'TUYA' || searchConditionForm.p2pType == 'TUYA_DAGONG' || searchConditionForm.p2pType == 'TUYA_CARDVR' || searchConditionForm.p2pType == 'QiHu360')"
            ></el-input>
          </el-form-item>
          <el-form-item label="默认型号" size="small">
            <el-input
              v-model="searchConditionForm.defaultModel"
              placeholder="默认型号"
              @keyup.enter.native="onSearch()"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="电池支持" size="small" v-if="this.activeLink=='IPC'">
            <el-select
                v-model="searchConditionForm.batterySupport"
                placeholder="选择是否支持"
                filterable
                clearable
            >
              <el-option
                  v-for="(item, index) in isBatteryOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目经理" size="small">
            <el-select
              v-model="searchConditionForm.managerId"
              placeholder="选择项目经理"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'manager', '员工选择', 'search')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.managerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>          
          <el-form-item label="校验和" size="small">
            <el-input
              v-model="searchConditionForm.checkSum"
              placeholder="校验和"
              @keyup.enter.native="onSearch()"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="firmwareSearchForm"
        class="demo-form-inline"
        v-else-if="
          isMoreSearch && tabPaneValue != 'first' && cutDetail == 'firmware'
        "
      >
        <div class="searchConditionBox">
          <el-form-item label="版本号" size="small">
            <el-input
              v-model="firmwareSearchForm.version"
              placeholder="固件版本号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="构建号" size="small">
            <el-input
              v-model="firmwareSearchForm.build"
              placeholder="输入构建号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="固件类型" size="small">
            <el-select
              v-model="firmwareSearchForm.type"
              placeholder="选择固件类型"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.firmwareTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布方" size="small">
            <el-select
              v-model="firmwareSearchForm.publisher"
              placeholder="选择发布方"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.publisherList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="定制客户" size="small">
            <el-select
              v-model="firmwareSearchForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" size="small">
            <el-select
              v-model="firmwareSearchForm.status"
              placeholder="选择状态"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.statusList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>

      <el-form
          :inline="true"
          :model="commandsSearchForm"
          class="demo-form-inline"
          v-else-if="
          tabPaneValue != 'first' && cutDetail == 'commands'
        "
      >
        <div class="searchConditionBox">
          <el-form-item label="固件版本" size="small">
            <el-select
                v-model="commandsSearchForm.firmwareList"
                placeholder="固件版本号"
                filterable
                @change="searchFactoryCommand"
            >
              <el-option
                  v-for="(item, index) in pullDownData.firmwareList"
                  :key="index"
                  :label="item.version"
                  :value="item.id"
              >{{ item.version }}</el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>

      <div
        class="tips tipsBox"
        v-show="tabPaneValue != 'first' && cutDetail == 'process' && isShowTips"
      >
        <span class="title">温馨提示：</span>
        <span class="text"
          >修改产品生产工序只对新工单有效，在产工单请在组装工单中修改生产工序。</span
        >
        <i class="el-icon-close close" @click="closeTips"></i>
      </div>
    </div>
    <div class="contentBox" v-if="tabPaneValue == 'first'">
      <div class="rightContent">
        <el-table stripe :data="tableData" border style="width: 100%" height="100%" size="mini" @sort-change="sortChange">
          <el-table-column type="index" :width="pagination.endIndex >= 1000 ? 80 : 50" align="center" :index="pagination.beginIndex"></el-table-column>
          <el-table-column prop="code" label="立项编码" align="center" sortable="custom" min-width="100px" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="allowSkip" @click="clickAllowSkip(scope.row)">
                {{scope.row.code}}
              </span>
            </template>
          </el-table-column>
          <el-table-column v-if="this.activeLink!='IPC'"
            prop="factoryToolsId" label="产测工具" align="center" sortable="custom" min-width="100px" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.factoryTools">
                {{scope.row.factoryTools.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="wlanSupport" label="无线网络" align="center" sortable="custom" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.wlanSupport && scope.row.wlanSupport.code!='NON_SUPPORT'" >
                {{ scope.row.wlanSupport.title }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="ethSupport" label="有线网络" align="center" sortable="custom" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.ethSupport && scope.row.ethSupport.code!='NON_SUPPORT'" >
                {{ scope.row.ethSupport.title }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="imeiSupport" label="蜂窝网络" align="center" sortable="custom" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.imeiSupport && scope.row.imeiSupport.code!='NON_SUPPORT'" >
                {{ scope.row.imeiSupport.title }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="btSupport" label="蓝牙" align="center" sortable="custom" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.btSupport && scope.row.btSupport.code!='NON_SUPPORT'" >
                {{ scope.row.btSupport.title }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column  v-if="this.activeLink=='IPC'" prop="batterySupport" label="电池支持" align="center" sortable="custom" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.batterySupport">
                支持
              </span>
              <span v-else>
                不支持
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="attachSnSupport" label="配件SN" align="center" sortable="custom" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.attachSnSupport && scope.row.attachSnSupport.code!='NON_SUPPORT'" >
                {{ scope.row.attachSnSupport.title }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column v-if="this.activeLink=='IPC'" prop="p2pType" label="Key类型" align="center" sortable="custom" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.p2pType && scope.row.p2pType.code != 'NONE'">
                {{ scope.row.p2pType.title }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column v-if="this.activeLink=='IPC'" prop="defaultPid" label="PID" align="center" sortable="custom" show-overflow-tooltip >
            <template slot-scope="scope">
              <span v-if="scope.row.defaultPid">{{
                scope.row.defaultPid
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="attachSnSupport" label="管理固件" align="center" sortable="custom" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.hasFw || scope.row.hasMcu || scope.row.hasWiFi || scope.row.hasBt">
                管理
              </span>
              <span v-else>
                不管理
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="checkSum" label="校验和" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.checkSum ? scope.row.checkSum : "-"}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="managerId" label="项目经理" align="center" sortable="custom" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.manager">{{ scope.row.manager.name }} ({{ scope.row.manager.employeeNum }})</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination :pagination="pagination" @currentChange="currentChange" @sizeChange="sizeChange" @refreshBtn="getProductSearch" ></pagination>
      </div>
    </div>
    <div class="contentBox" v-else>
      <div class="rightContent" v-if="cutDetail == 'detail'">
        <detailPage
          ref="detailPage"
          :tabPaneValue="tabPaneValue"
          @productDetailLoaded="productDetailData = $event"
        ></detailPage>
      </div>
      <processPage
        ref="processPage"
        v-else-if="cutDetail == 'process'"
        :tabPaneValue="tabPaneValue"
      ></processPage>
      <firmwareManage
        ref="firmwareManage"
        v-else-if="cutDetail == 'firmware'"
        :tabPaneValue="tabPaneValue"
        :firmwareSearchForm="firmwareSearchForm"
      ></firmwareManage>
      <commands
        ref="commands"
        v-else-if="cutDetail == 'commands'"
        :tabPaneValue="tabPaneValue"
        :commandsSearchForm="commandsSearchForm"
        :tabProductName="tabProductName"
        :isShowCommandsNameInput="isShowCommandsNameInput"
        @updatePageData="updatePageData"
      ></commands>
      <battery
        ref="battery"
        v-else-if="cutDetail == 'battery'"
        :tabPaneValue="tabPaneValue"
      ></battery>
      <iq
        ref="iq"
        v-else-if="cutDetail == 'iq'"
        :tabPaneValue="tabPaneValue"
      ></iq>
    </div>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="680px"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <el-form-item
            label="立项编码"
            size="small"
            prop="code"
            class="inlineItem"
          >
            <el-input
              v-model="dialogForm.code"
              placeholder="产品立项编码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="产品类别"
            size="small"
            prop="productType"
            class="inlineItem"
          >
            <el-select
              v-model="dialogForm.productType"
              placeholder="选择产品类别"
                filterable
              clearable
              @change="addProductTypeChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="默认型号"
            size="small"
            prop="defaultModel"
            class="inlineItem"
          >
            <el-input
              v-model="dialogForm.defaultModel"
              placeholder="未烧录前，设备默认的型号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="项目经理"
            size="small"
            prop="managerId"
            class="inlineItem"
          >
            <el-select
              v-model="dialogForm.managerId"
              placeholder="选择项目经理"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'manager', '员工选择', 'add')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.managerAddList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Key类型" size="small" prop="p2pType" class="inlineItem">
            <el-select v-model="dialogForm.p2pType" placeholder="选择Key类型" filterable clearable
              @change="p2pTypeChange($event, 'dialogForm', 'p2pItemCode')">
              <el-option v-for="(item, index) in pullDownData.p2pTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="PID" size="small" prop="defaultPid" class="inlineItem">
            <el-input v-model="dialogForm.defaultPid" placeholder="PID" clearable
              :disabled="!(dialogForm.p2pType == 'NONE' || dialogForm.p2pType == 'LinkView' || dialogForm.p2pType == 'LinkViewByWakeUp'  || dialogForm.p2pType == 'TUYA' || dialogForm.p2pType == 'TUYA_DAGONG' || dialogForm.p2pType == 'TUYA_CARDVR' || dialogForm.p2pType == 'Wyze' || dialogForm.p2pType == 'QiHu360')"
            ></el-input>
          </el-form-item>
          <el-form-item label="Key物料编码" size="small" prop="p2pItemCode" class="inlineItem" v-if="dialogForm.p2pType != 'NetId'">
            <el-input v-model="dialogForm.p2pItemCode"
              placeholder="Key的物料编码"
              clearable
              :disabled="searchConditionForm.p2pType == 'NONE' || dialogForm.p2pType != 'NetId' && dialogForm.p2pType != 'TUYA' && dialogForm.p2pType != 'DPK' && dialogForm.p2pType != 'TUYA_DAGONG' && dialogForm.p2pType != 'TUYA_CARDVR' && dialogForm.p2pType != 'TUTK' && dialogForm.p2pType != 'SUNMI'"
            ></el-input>
          </el-form-item>
          <el-form-item label="Key物料编码" size="small" prop="p2pItemCode" class="inlineItem" v-else>            
            <el-select v-model="dialogForm.p2pItemCode" placeholder="请输入物料编码" filterable clearable>
              <el-option
                  v-for="(item, index) in pullDownData.netIdItemCodeList"
                  :key="index"
                  :label="item.itemCode"
                  :value="item.itemCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="产测工具"
            size="small"
            prop="factoryToolsId"
            class="inlineItem"
          >
            <el-select
              v-model="dialogForm.factoryToolsId"
              placeholder="根据嵌入式支持的协议选择"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.factoryToolsList2"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="导入SN/UUID"
            size="small"
            prop="importSn"
            class="inlineItem"
          >
            <el-radio v-model="dialogForm.importSn" :label="true"
              >导入</el-radio
            >
            <el-radio v-model="dialogForm.importSn" :label="false"
              >不导入</el-radio
            >
          </el-form-item>
          <el-form-item label="校验和" size="small" prop="checkSum" class="inlineItem">
            <el-input v-model="dialogForm.checkSum" placeholder="checkSum" clearable></el-input>
          </el-form-item>
          <el-form-item
            label="固件版本管理"
            size="small"
            prop="hasFw"
          >
            <el-checkbox v-model="dialogForm.hasFw">Flash固件</el-checkbox>
            <el-checkbox v-model="dialogForm.hasMcu">MCU单片机</el-checkbox>
            <el-checkbox v-model="dialogForm.hasWiFi">WiFi网卡</el-checkbox>
            <el-checkbox v-model="dialogForm.hasBt">Bluetooth蓝牙</el-checkbox>
          </el-form-item>
          <el-form-item label="MAC提供方" size="small" prop="macSupport" class="inlineItem">
            <el-select v-if="dialogTitle=='修改产品型号'"
              v-model="dialogForm.macSupport.code" placeholder="选择MAC的提供方式" filterable
            >
              <el-option
                v-for="(item, index) in pullDownData.macSupportType"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select><el-select v-else
              v-model="dialogForm.macSupport" placeholder="选择MAC的提供方式" filterable
            >
              <el-option
                v-for="(item, index) in pullDownData.macSupportType"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="无线MAC" size="small" prop="wlanSupport" class="inlineItem">
            <el-select v-if="dialogTitle=='修改产品型号'"
              v-model="dialogForm.wlanSupport.code" placeholder="无线MAC的烧录方式" filterable
            >
              <el-option
                v-for="(item, index) in pullDownData.supportType"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
            <el-select v-else
              v-model="dialogForm.wlanSupport" placeholder="无线MAC的烧录方式" filterable
            >
              <el-option
                v-for="(item, index) in pullDownData.supportType"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="有线MAC" size="small" prop="ethSupport" class="inlineItem">
            <el-select v-if="dialogTitle=='修改产品型号'"
              v-model="dialogForm.ethSupport.code" placeholder="有线MAC的烧录方式" filterable
            >
              <el-option
                v-for="(item, index) in pullDownData.supportType"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
            <el-select v-else
              v-model="dialogForm.ethSupport" placeholder="有线MAC的烧录方式" filterable
            >
              <el-option
                v-for="(item, index) in pullDownData.supportType"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="蓝牙MAC" size="small" prop="btSupport" class="inlineItem">
            <el-select v-if="dialogTitle=='修改产品型号'"
              v-model="dialogForm.btSupport.code" placeholder="蓝牙MAC的烧录方式" filterable
            >
              <el-option
                v-for="(item, index) in pullDownData.supportType"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
            <el-select v-else
              v-model="dialogForm.btSupport" placeholder="蓝牙MAC的烧录方式" filterable
            >
              <el-option
                v-for="(item, index) in pullDownData.supportType"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="IMEI" size="small" prop="imeiSupport" class="inlineItem">
            <el-select v-if="dialogTitle=='修改产品型号'"
              v-model="dialogForm.imeiSupport.code" placeholder="IMEI的烧录方式" filterable
            >
              <el-option
                v-for="(item, index) in pullDownData.supportType"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
            <el-select v-else
              v-model="dialogForm.imeiSupport" placeholder="IMEI的烧录方式" filterable
            >
              <el-option
                v-for="(item, index) in pullDownData.supportType"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="配件SN" size="small" prop="attachSnSupport" class="inlineItem">
            <el-select v-if="dialogTitle=='修改产品型号'"
              v-model="dialogForm.attachSnSupport.code" placeholder="配件SN的烧录方式" filterable
            >
              <el-option
                v-for="(item, index) in pullDownData.supportType"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
            <el-select v-else
              v-model="dialogForm.attachSnSupport" placeholder="配件SN的烧录方式" filterable
            >
              <el-option
                v-for="(item, index) in pullDownData.supportType"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电池支持" size="small" prop="batterySupport" class="inlineItem">
            <el-radio v-model="dialogForm.batterySupport" :label="true">支持</el-radio>
            <el-radio v-model="dialogForm.batterySupport" :label="false">不支持</el-radio>
          </el-form-item>
          <el-form-item label="AP/SetupCode" size="small" prop="apPassword" class="inlineItem">
            <el-radio v-model="dialogForm.apPassword" :label="true">系统生成</el-radio>
            <el-radio v-model="dialogForm.apPassword" :label="false">不支持</el-radio>
          </el-form-item>
          
          <el-form-item label="语音识别" size="small" prop="voice" class="inlineItem">
            <el-radio v-model="dialogForm.voice" :label="true">支持</el-radio>
            <el-radio v-model="dialogForm.voice" :label="false">不支持</el-radio>
          </el-form-item>
          
          <el-form-item label="ADAS" size="small" prop="adas" class="inlineItem">
            <el-radio v-model="dialogForm.adas" :label="true">支持</el-radio>
            <el-radio v-model="dialogForm.adas" :label="false">不支持</el-radio>
          </el-form-item>
          <el-form-item label="IQ二进制" size="small" prop="hasIq" class="inlineItem">
            <el-radio v-model="dialogForm.hasIq" :label="true">有</el-radio>
            <el-radio v-model="dialogForm.hasIq" :label="false">无</el-radio>
          </el-form-item>
          <el-form-item label="备注" size="small" prop="notes" class="inlineItem">
            <el-input v-model="dialogForm.notes" clearable></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
    <orderTableSelect
      ref="orderTableSelect"
      @orderTableSubmit="orderTableSubmit"
    ></orderTableSelect>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import orderTableSelect from "@/components/orderTableSelect.vue";
import detailPage from "./components/detailPage.vue";
import processPage from "./components/processPage.vue";
import firmwareManage from "./components/firmwareManage.vue";
import commands from "./components/commands.vue";
import battery from "./components/battery.vue";
import iq from "./components/iq.vue";
import {
  apiProductSearch,
  apiProductAdd,
  apiProductUpdate,
  apiFactoryToolsList,
  apiSupportType,
  apiMacSupportType,
  apiProductTypeList,
  // apiManagerList,
  apiP2PType,apiNetIdItemCodeList,
  apiWorkStationList,
  apiProductLockSop,apiProductUnlockSop,
} from "@/api/productModel.js";
import {
  apiFirmwareTypeList,
  apiPublisherList,
  apiStatusList,
  apiCustomerList, apiFirmwareListVersion
} from "@/api/firmwareManage.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/productModel" },
  components: {
    pagination,
    myDialog,
    orderTableSelect,
    detailPage,
    processPage,
    commands,
    battery,
    iq,
    firmwareManage,
  },
  data() {
    var p2pTypeRule = (rule, value, callback) => {
      if (!value && this.dialogForm.productType == "IPC") {
        return callback(new Error("Key类型不能为空！"));
      } else {
        callback();
      }
    };
    return {
      tabPaneValue: "first",
      tabProductId:"",
      tabProductName:"",
      tabPaneList: [],
      activeLink: null,
      cutDetail: "detail",
      productDetailData: {},
      isShowTips: true,
      isMoreSearch: false,
      searchConditionForm: {},
      firmwareSearchForm: {},
      commandsSearchForm: {
        firmwareList: "",
        firmwareVersion: ""
      },
      commandId:"",
      pullDownData: {
        p2pTypeList: [],
        netIdItemCodeList:[],
        dewarpTypeList: [{ label: "PUWELL", value: "PUWELL" }],
        macSupportType: [],
        supportType: [],
        managerList: [],
        managerAddList: [],
        factoryToolsList: [],
        factoryToolsList2: [],
        productTypeList: [],
        workStationList: [],
        firmwareTypeList: [],
        firmwareList: [],
        publisherList: [],
        statusList:[],
        customerList: [],
      },
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      dialogTitle: "",
      dialogForm: {
        productType: null,
        macSupport: 'BY_MODULE',
        wlanSupport: 'NON_SUPPORT',
        ethSupport: 'NON_SUPPORT',
        imeiSupport: 'NON_SUPPORT',
        btSupport: 'NON_SUPPORT',
        attachSnSupport: 'NON_SUPPORT',
        apPassword: false,
        batterySupport: false,
        adas: false,
        voice: false,
        importSn: false,
        hasFw:true,
        hasIq: false
      },
      dialogRules: {
        productType: [
          { required: true, message: "产品类别不能为空！", trigger: "blur" },
        ],
        code: [
          { required: true, message: "立项编码不能为空！", trigger: "blur" },
          {
            min: 4,
            max: 64,
            message: "长度在 4 到 64 个字符",
            trigger: "blur",
          },
        ],
        defaultModel: [
          { required: true, message: "默认型号不能为空！", trigger: "blur" },
        ],
        p2pType: [{ validator: p2pTypeRule, trigger: "change" }],
        factoryToolsId: [
          { required: true, message: "产测工具不能为空！", trigger: "change" },
        ],
      },
      isBatteryOption:[{
        value: true,
        label: '支持'
      }, {
        value: false,
        label: '不支持'
      }],
      labelWidth: "90px",
      // labelWidth: this.$store.state.labelWidth
      currentProcessKey: "",
      isShowCommandsNameInput:false,
    };
  },
  provide(){
    return
  },
  watch: {
    tabPaneValue: function (newVal) {
      this.$moreSearchStyle();
      if (newVal == "first") {
        this.getProductSearch();
      } else {
        this.$nextTick(() => {
          if (this.cutDetail == "detail") {
            this.$refs.detailPage.getProductDetail();
          } else if (this.cutDetail == "process") {
            this.$refs.processPage.currentProcessKey = this.currentProcessKey;
            this.$refs.processPage.getProductionLineData();
            this.$refs.processPage.getProductSopSearch();
          } else if (this.cutDetail == "firmware") {
            this.$refs.firmwareManage.getFirmwareSearch();
          } else if (this.cutDetail == "commands") {
            this.apiFirmwareList(this.$refs.commands.tabPaneValue);
          } else if (this.cutDetail == "battery") {
            this.$refs.battery.loadData();
          } else if (this.cutDetail == "iq") {
            this.$refs.iq.loadData();
          }
        });
      }
    },
  },
  methods: {
    // 查询/新建-产品类别改变
    p2pTypeChange(value, formName, p2pItemCode) {
      this.$set(this[formName], p2pItemCode, undefined);
    },
    updatePageData(commandId){
      this.commandId = commandId;
      console.log("index:"+this.commandId);
    },
    // 切换一级面板
    tabPaneClick(tab) {
      this.tabPaneValue = tab.name;
    },
    // 关闭一级面板
    closeTabPane(index) {
      if (this.tabPaneList[index].id == this.tabPaneValue) {
        if (index > 0) {
          this.tabPaneValue = this.tabPaneList[index - 1].id;
        } else {
          this.tabPaneValue = "first";
        }
      }
      this.tabPaneList.splice(index, 1);
    },
    searchFactoryCommand(){
      this.$refs.commands.loadData();
    },
    // 型号管理子tab标签点击
    modelClick(model) {
      if (this.activeLink!=model) {
        this.isMoreSearch = false;
        this.$moreSearchStyle();
      }
      this.activeLink = model;
      this.$set(this.searchConditionForm, "factoryToolsId", ""); // 查询条件-产测工具
      this.pagination.currentPage = 1;
      this.getProductSearch(); // 型号分页
      this.getFactoryToolsList(); // 产测工具列表
    },
    // 切换详情-二级面板
    cutDetailChange(value) {
      this.cutDetail = value;
      this.$moreSearchStyle();
      this.$nextTick(() => {
        if (value == "detail") {
          this.$refs.detailPage.getProductDetail();
        } else if (value == "process") {
          this.$refs.processPage.currentProcessKey = this.currentProcessKey;
          this.$refs.processPage.getProductionLineData();
          this.$refs.processPage.getProductSopSearch();
        } else if (this.cutDetail == "firmware") {
          this.$refs.firmwareManage.getFirmwareSearch();
        } else if (this.cutDetail == "commands") {
          this.apiFirmwareList(this.$refs.commands.tabPaneValue);
        } else if (this.cutDetail == "battery") {
          this.$refs.battery.loadData();
        } else if (this.cutDetail == "iq") {
          this.$refs.iq.loadData();
        }
      });
    },
    // 关闭温馨提示
    closeTips() {
      this.isShowTips = false;
      this.$moreSearchStyle();
    },
    // 表格数据
    async getProductSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiProductSearch({
        productType: this.activeLink,
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 复制
    copyBtn() {
        this.$refs.commands.copyBtn();
    },
    addBattery() {
        this.$refs.battery.addBattery();
    },
    addIq() {
        this.$refs.iq.addIq();
    },
    // 新增
    addNewBtn() {
      if (this.tabPaneValue == "first") {
        this.dialogTitle = "新增产品型号";
        this.dialogForm.productType = this.activeLink; // 新建产品-产品类别
        this.getFactoryToolsList2(); // 新建产品-产测工具
        this.getSupportType();
        this.getMacSupportType();
        this.$refs.myDialog.dialogVisible = true;
      } else {
        if (this.cutDetail == "process") {
          this.$refs.processPage.addNewBtn();
        } else if(this.cutDetail == "firmware") {
          this.$refs.firmwareManage.addNewBtn();
        } else if(this.cutDetail=="commands") {
          this.isShowCommandsNameInput=false;
          this.$refs.commands.editBtn();
        }
      }
    },
    addNewComandBtn(){
      this.isShowCommandsNameInput=true;
      this.$refs.commands.editBtn(null,"新增产测指令");
    },
    deleteCommandArrayBtn(){
      this.$refs.commands.deleteArrayBtn();
    },
    // 详情页修改产品型号
    editProductBtn() {
      // console.log(data);
      let data = this.$refs.detailPage.productDetailData
      this.dialogTitle = "修改产品型号";
      this.dialogForm = {
        ...data,
        productType: data.productType ? data.productType.code : undefined,
        managerId: data.manager ? data.manager.id : undefined,
        p2pType: data.p2pType ? data.p2pType.code : undefined,
        factoryToolsId: data.factoryTools ? data.factoryTools.id : undefined,
        factoryTools: undefined,
        manager: undefined,
      };
      this.pullDownData.managerAddList = data.manager ? [data.manager] : [];
      this.getFactoryToolsList2(); // 修改产品-产测工具
      this.getSupportType();
      this.getMacSupportType();
      this.$refs.myDialog.dialogVisible = true;
    },
    // 锁定工序
    lockSopBtn() {
      const h = this.$createElement;
      const code = this.productDetailData.code;
      this.$msgbox({
        title: `警告：锁定后该产品工序将不能修改！`,
        message: h("div", null, [
          h("span", null, `请输入立项编码:【`),
          h("i", { style: "color: var(--themeColor)" }, code),
          h("span", null, `】以确认锁定工序！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == code) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiProductLockSop({ id: this.tabPaneValue });
        if (res.code == 0) {
          this.$refs.detailPage.getProductDetail();
          this.$message({ message: "锁定成功", type: "success" });
        }
      });
    },
    // 解锁工序
    unlockSopBtn() {
      const h = this.$createElement;
      const code = this.productDetailData.code;
      this.$msgbox({
        title: `警告：解锁后该产品工序可被修改！`,
        message: h("div", null, [
          h("span", null, `请输入立项编码:【`),
          h("i", { style: "color: var(--themeColor)" }, code),
          h("span", null, `】以确认解锁工序！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == code) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiProductUnlockSop({ id: this.tabPaneValue });
        if (res.code == 0) {
          this.$refs.detailPage.getProductDetail();
          this.$message({ message: "解锁成功", type: "success" });
        }
      });
    },
    // 新增产品型号产品类别改变
    addProductTypeChange() {
      this.$set(this.dialogForm, "factoryToolsId", undefined);
      this.getSupportType();
      this.getMacSupportType();
      this.getFactoryToolsList2(); // 修改产品-产测工具
    },
    // 对话框确认按钮
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          if (title == "新增产品型号") {
            const res = await apiProductAdd({
              ...this.dialogForm,
            });
            // console.log(res);
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.onSearch();
              this.$message({
                message: "新增成功",
                type: "success",
              });
            }
          } else if (title == "修改产品型号") {
            const res = await apiProductUpdate({
              ...this.dialogForm,
              macSupport: this.dialogForm.macSupport.code,
              wlanSupport: this.dialogForm.wlanSupport.code,
              ethSupport: this.dialogForm.ethSupport.code,
              imeiSupport: this.dialogForm.imeiSupport.code,
              btSupport: this.dialogForm.btSupport.code,
              attachSnSupport: this.dialogForm.attachSnSupport.code
            });
            // console.log(res);
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.$refs.detailPage.getProductDetail();
              this.tabPaneList.forEach((item, index) => {
                if (item.id == res.data.id) {
                  this.tabPaneList.splice(index, 1, res.data);
                  return;
                }
              });
              this.$message({
                message: "修改成功",
                type: "success",
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {
        productType: this.activeLink,
        macSupport: 'BY_MODULE',
        ethSupport: 'NON_SUPPORT',
        wlanSupport: 'NON_SUPPORT',
        apPassword: false,
        batterySupport: false,
        voice: false,
        adas: false,
        btSupport: 'NON_SUPPORT',
        imeiSupport: 'NON_SUPPORT',
        attachSnSupport: 'NON_SUPPORT',
        importSn: false,
        hasFw: true,
        hasIq: false
      };
    },
    // 清除查询
    onClear() {
      if(this.tabPaneValue == "first") {
        this.searchConditionForm = {};
        this.pagination.currentPage = 1;
        this.getProductSearch();
      } else {
        if(this.cutDetail == "firmware") {
          this.firmwareSearchForm = {}
          this.$nextTick(() => {
            this.$refs.firmwareManage.onClear();
          })
        }
      }
    },
    // 确认查询
    onSearch() {
      if(this.tabPaneValue == "first") {
        this.pagination.currentPage = 1;
        this.getProductSearch();
      } else {
        if(this.cutDetail == "firmware") {
          this.$refs.firmwareManage.onSearch();
        }
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getProductSearch();
    },
    // 查询条件-发布开始时间
    startDateChange() {
      let { startDate, endDate } = this.firmwareSearchForm;
      if (startDate > endDate) {
        this.firmwareSearchForm.endDate = this.firmwareSearchForm.startDate;
      }
    },
    // 查询条件-发布结束时间
    endDateChange() {
      let { startDate, endDate } = this.firmwareSearchForm;
      if (startDate > endDate) {
        this.firmwareSearchForm.startDate = this.firmwareSearchForm.endDate;
      }
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getProductSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.getProductSearch();
    },
    // 表格列组装工单点击
    clickAllowSkip(row) {
      this.tabPaneValue = row.id;
      this.tabProductId = row.id;
      this.tabProductName = row.code;
      let tabPaneIds = this.tabPaneList.map((item) => item.id);
      if (tabPaneIds.includes(row.id)) {
        this.tabPaneList.splice(tabPaneIds.indexOf(row.id), 1, row);
      } else {
        this.tabPaneList.push(row);
      }
      //获取固件版本号
      this.apiFirmwareList(this.tabProductId);
    },
    // 弹框选择
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        // console.log(orderName, labelName)
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.origin = origin;
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 弹框表格提交
    orderTableSubmit({ orderName, selectRow, origin }) {
      if (origin == "search") {
        this.$set(
          this.searchConditionForm,
          `${orderName + "Id"}`,
          selectRow.id
        );
        this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
      } else if (origin == "add") {
        this.$set(this.dialogForm, `${orderName + "Id"}`, selectRow.id);
        this.$set(this.pullDownData, `${orderName + "AddList"}`, [selectRow]);
      }
    },
    // Key类型下拉
    async getP2PType() {
      const res = await apiP2PType();
      if (res.code == 0) {
        this.pullDownData.p2pTypeList = res.data;
      }
      const res2 = await apiNetIdItemCodeList();
      if (res2.code == 0) {
        this.pullDownData.netIdItemCodeList = res2.data;
      }
    },
    // 产测工具下拉数据
    async getFactoryToolsList() {
      const res = await apiFactoryToolsList({
        productType: this.activeLink,
      });
      if (res.code == 0) {
        this.pullDownData.factoryToolsList = res.data;
      }
    },
    async getMacSupportType() {
      const res = await apiMacSupportType();
      if (res.code == 0) {
        this.pullDownData.macSupportType = res.data;
      }
    },
    async getSupportType() {
      const res = await apiSupportType();
      if (res.code == 0) {
        this.pullDownData.supportType = res.data;
      }
    },
    // 新建产测工具下拉数据
    async getFactoryToolsList2() {
      const res = await apiFactoryToolsList({
        productType: this.dialogForm.productType,
      });
      if (res.code == 0) {
        this.pullDownData.factoryToolsList2 = res.data;
      }
    },
    // 产品类别下拉数据
    async getProductTypeList() {
      const res = await apiProductTypeList();
      if (res.code == 0) {
        this.pullDownData.productTypeList = res.data;
      }
    },
    // 生产工序-工序下拉
    async getWorkStationList() {
      const res = await apiWorkStationList();
      if (res.code == 0) {
        this.pullDownData.workStationList = res.data;
      }
    },
    // 固件类型下拉
    async getFirmwareTypeList() {
      const res = await apiFirmwareTypeList();
      if (res.code == 0) {
        this.pullDownData.firmwareTypeList = res.data;
      }
    },
    // 固件版本下拉
    async apiFirmwareList(tabProductId) {
      const res = await apiFirmwareListVersion({
        productId: tabProductId
      });
      if (res.code == 0) {
        console.log("index:"+res.data);
        this.pullDownData.firmwareList = res.data;
        if(this.pullDownData.firmwareList.length == 0){
          this.commandsSearchForm.firmwareList = "";
        }else{
          this.commandsSearchForm.firmwareList = this.pullDownData.firmwareList[0].id;
          this.commandsSearchForm.firmwareVersion = this.pullDownData.firmwareList[0].version;
        }
      }
      this.$refs.commands.loadData();
    },

    // 发布方下拉
    async getPublisherList() {
      const res = await apiPublisherList();
      if (res.code == 0) {
        this.pullDownData.publisherList = res.data;
      }
    },
    // 状态列表
    async getStatusList() {
      const res = await apiStatusList();
      if (res.code == 0) {
        this.pullDownData.statusList = res.data;
      }
    },
    // 客户名称下拉
    async getCustomerList() {
      const res = await apiCustomerList();
      if (res.code == 0) {
        this.pullDownData.customerList = res.data;
      }
    },
    callback() {
      this.getFactoryToolsList();
      this.getP2PType();
      this.getProductTypeList();
      this.getWorkStationList();
      this.getFirmwareTypeList();
      this.getPublisherList();
      this.getStatusList();
      this.getCustomerList();
    },
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    if (this.tabPaneValue == "first") {
      this.getProductSearch("", this.callback);
    } else {
      if (this.cutDetail == "detail") {
        this.$refs.detailPage.getProductDetail("", this.callback);
      } else if (this.cutDetail == "firmware") {
          this.$refs.firmwareManage.getFirmwareSearch("", this.callback);
      } else if (this.cutDetail == "process") {
        this.$refs.processPage.getProductionLineData();
        this.$refs.processPage.getProductSopSearch("", this.callback);
      } else if (this.cutDetail == "commands") {
        this.$refs.commands.loadData();
      }
    }
  },
  deactivated() {
    window.onresize = null;
  },
};
</script>

<style lang="less" scoped>
</style>
